
<template>
  <!-- user-info-view .civ -->
  <div class="civ">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem to="/host/index/home">首页</BreadcrumbItem>
          <BreadcrumbItem>供需信息</BreadcrumbItem>
          <BreadcrumbItem>用户供需信息</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">供需信息</div>
      </div>
      <div class="header-tool-box">
        <div class="htb-item" @click="$router.push('/host/index/supply-info/supply-export')">
          <i class="icon iconfont icon-downLoad2"></i>
          <span>导出明细</span>
        </div>
      </div>
    </div>
    <div class="header-switch">
      <div class="header-switch-text">记录所有用户供需信息</div>
      <div class="header-switch-box">
        <RadioGroup v-model="allDone" type="button" @on-change="changeRadio">
          <Radio label="待处理"></Radio>
          <Radio label="已处理"></Radio>
        </RadioGroup>
      </div>
    </div>
    <div class="header-tabs">
      <Tabs :animated="false" @on-click="switchBrand" v-model="showTabs">
        <TabPane label="全部" name="全部">
          <supplyUserInfoAll v-if="showTabs === '全部'" :status="handleStatus" />
        </TabPane>
        <TabPane :label="item.name" :name="item.id" v-for="(item, index) in list2" :key="item.id">
          <supplyUserInfoCheck :releaseType="item.id" v-if="showTabs === item.id" :status="handleStatus" />
        </TabPane>
      </Tabs>
    </div>
  </div>
</template>

<script>
import supplyUserInfoAll from "./subpages/supply-user-info-all.vue";
import supplyUserInfoCheck from "./subpages/supply-user-info-check.vue";
import { mapActions } from "vuex";

export default {
  name: "host-supply-user-info",
  data () {
    return {
      list2: [],
      showTabs: "",
      show: false,
      allDone: "待处理",
      handleStatus: "0" // 0：Submited=已提交  1： Audited=已审核
    };
  },
  computed: {
    exhibitionInfo () {
      if (JSON.parse(localStorage.vuex)) {
        return JSON.parse(localStorage.vuex).hostSetModule.hostExhibition;
      }
    }
  },
  components: {
    supplyUserInfoCheck,
    supplyUserInfoAll
  },
  async created () {
    let listData = await this.getReleaseType(this.exhibitionInfo.id);
    this.showTabs = "全部";
    if (listData && listData.length) {
      this.list2 = listData;
    }
    this.changeTab();
  },
  methods: {
    ...mapActions({
      getReleaseType: "momentModule/getReleaseType"
    }),
    changeTab () {
      let query = this.$route.query;
      if (query.type === "全部") {
        this.showTabs = query.type;
        return;
      }
      if (query && query.type) {
        this.list2.forEach(c => {
          if (c.id === query.type) {
            this.showTabs = c.id;
          }
        });
      }
    },
    switchBrand (name) {
      if (name) {
        this.$router.push(`${this.$route.path}?type=${name}`);
        this.handleStatus = "0";
        this.allDone = "待处理";
      }
    },
    showAdd (name) {
      this.$refs[name].showAdd();
    },
    changeRadio (e) {
      if (e === "待处理") {
        this.handleStatus = "0";
      } else if (e === "已处理") {
        this.handleStatus = "1";
      }
      console.log(this.handleStatus);
    }
  }
};
</script>

<style scoped lang="scss">
.header-switch {
  display: flex;
  align-items: center;
  padding: 0 35px 18px 35px;
  background: #fff;
  &-text {
    flex: 1;

    font-size: 14px;
    color: #808080;
  }
  &-box {
    flex: 1;
    text-align: right;
  }
}
</style>
